import { IHocKyDangKy } from "../../../model/respone/category/IHocKyDangKy";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHocKyDangKyActionsObj = {
  LOAD_START: 0,
  LOAD_SUCCESS: {} as IHocKyDangKy[],
  LOAD_ERRR: "",

  SAVE_START: undefined,
  SAVE_SUCCESS: {} as IHocKyDangKy,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

  SHOW_EDIT_MODAL: {} as undefined | IHocKyDangKy,
  CLOSE_EDIT_MODAL: undefined,
};
export const eHocKyDangKyActionIds = generateActionTypeIds(
  eHocKyDangKyActionsObj,
  "HOC_KY_DANG_KY"
);
export type IHocKyDangKyActionTypes = IGenericActionType<
  typeof eHocKyDangKyActionsObj,
  "HOC_KY_DANG_KY"
>;
